import { size, get, isNil, includes, filter } from "lodash"
import { createSelector } from "reselect"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeEntityPermissionsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"
import { STATUSES } from "../../platform/constants"
import { STATUSES as FEATURE_STATUSES } from "components/feature-permissions/helpers"

const EMPTY_ARRAY = []

const getProMemberLimit = (state) => get(state, "global.selected.accountMeta.planLimits.memberLimit")
export const getMembers = (state) => get(state, "global.data.members.data")
const getFeatures = state => get(state, "global.data.features.data")
export const getMemberFeatures = state => get(state, "modules.members.memberFeatures", EMPTY_ARRAY)
export const getMemberFeaturesLoading = state => get(state, "modules.members.memberFeaturesLoading")
export const getAccountFeatures = state => get(state, "global.data.accountFeatures.data", EMPTY_ARRAY)

export const getTabs = createSelector(
  [getRoute, getPath, getIsOpPro],
  computeEntityPermissionsTabs,
)

/** Returns a disabled message if account has pro plan and is at/over the member limit */
export const getOverProMemberLimitMessage = createSelector(
  [getIsOpPro, getProMemberLimit, getMembers],
  (isOpPro, proMemberLimit, members) => {
    // Not pro, don't disable
    if (!isOpPro) {
      return null
    }
    // Still fetching, disable for pro
    if (isNil(proMemberLimit) || isNil(members)) {
      return "Determining if this account has reached member limit..."
    }
    // At or over limit, disable for pro
    return size(members) >= proMemberLimit
      ? `You have reached the member limit (${proMemberLimit}) for this plan`
      : null
  },
)

export const getHasEzeIntegration = (state) => includes([STATUSES.REQUESTED, STATUSES.ACTIVE], get(state, "global.data.ezeMetadata.data.status"))

export const getRestrictedFeatures = createSelector(
  [getFeatures],
  (features) => filter(features, ({ status }) => status === FEATURE_STATUSES.RESTRICTED),
)
